<template>
    <div>

        <v-form ref="formDatos" lazy-validation>
            <v-dialog v-model="modalSelecClaseEC" persistent scrollable max-width="90%">
                <v-card>
                    <v-card-title class="btn_otro">
                        <v-row class="d-flex justify-space-between py-0">
                            Seleccionar Clase
                            <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
                        </v-row>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text>
                        <v-row class="mt-2">
                            <v-col cols="12" sm="3" md="auto" class="py-0">
                                <span style="font-size: 16px">Contenidos</span>
                                <v-radio-group v-model="asociarCl.contenidoTipo"  @change="cargarQueryContenido" row class="mt-0">
                                    <v-radio :label="`Inteligenio`" :value="1"></v-radio>
                                    <v-radio :label="$t('titulo.colegio')" :value="0"></v-radio>
                                </v-radio-group>
                            </v-col>


                            <v-col cols="12" sm="3" md="" class="py-0"  v-if="visualizarFiltro">
                                <v-autocomplete label="Nivel" v-model="asociarCl.id_nivel" :items="nivelCont"
                                    :item-value="id_nivelFiltro" item-text="desc_nivel" @change="eventNivelCl" :disabled="inhabilitarNivelCl" autocomplete="off">
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="3" md="" class="py-0"   v-if="visualizarFiltro" >
                                <v-autocomplete label="Grado" v-model="asociarCl.id_grado" :items="gradoContFilter"
                                    :item-value="id_gradoFiltro" item-text="desc_grado" @change="eventGradoCl" :disabled="inhabilitarGradoCl" autocomplete="off">
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="3" md="" class="py-0">
                                <v-autocomplete label="Área" v-model="asociarCl.id_area" :items="areaContFilter"
                                    :item-value="id_areaFiltro" item-text="desc_area" @change="eventAreaCl" :disabled="inhabilitarAreaCl" autocomplete="off">
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="3" md="" class="py-0">
                                <v-autocomplete :label="$t('titulo.curso')" v-model="asociarCl.id_curso" :items="cursoContFilter"
                                    :item-value="id_cursoFiltro" item-text="desc_curso" @change="cargarClases" :disabled="inhabilitarCursoCl" autocomplete="off">
                                </v-autocomplete>
                            </v-col>


                            <v-col cols="4" md="" class="py-0">
                                <v-text-field label="Buscar" v-model="search_asociarCl" append-icon="fa-search" single-line hide-details ></v-text-field>
                            </v-col>
                        </v-row>


                        <!-- DATA TABLE CONTENIDOS DE CLICKEN1 -->
                        <v-data-table v-if="tablaCk1" :headers="headers_clases" :items="clases" :height="600"
                        :search="search_asociarCl" class="elevation-1 black--text" :fixed-header="true">


                            <template v-slot:[`item.estadoValor`]="{ item }">
                                <v-chip v-if="item.clase_programada===1" small class="color_activo">
                                    Programado
                                </v-chip>

                                <v-chip v-else small class="color_otro">
                                    Sin Programar
                                </v-chip>
                            </template>


                            <template v-slot:[`item.programar`]="{ item }">
                                <v-btn class="btn_block_style2" v-if="item.clase_programada===0" small dark  @click="$emit('addselecclaseec', item, asociarCl.contenidoTipo)"> PROGRAMAR</v-btn>
                            </template>


                            <template v-slot:[`item.action_ver`]="{ item }">
                                <v-tooltip bottom color="#1b1b1b">
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-if="componenteEvento.visualizar_submodulo" v-on="on" class="btn_ver px-0 mx-0" fab x-small @click="$emit('visorec', item.id_clase, asociarCl.contenidoTipo)">
                                            <v-icon>fa-eye</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>VER CLASE</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>




                        <!-- DATA TABLE CONTENIDOS DEL COLEGIO -->
                        <v-data-table v-else :headers="headers_clases_colegio" :items="clasesColegio"
                        :search="search_asociarCl" class="elevation-1 black--text" fixed-header>

                            <template v-slot:[`item.fechaCreacion`]="{ item }">
                                {{item.fec_us_ing| filtroFecha}}
                            </template>


                            <template v-slot:[`item.estadoValor`]="{ item }">
                                <v-chip v-if="item.clase_programada===1" pill small class="color_activo font-weight-black">
                                    Programado
                                </v-chip>

                                <v-chip v-else pill small class="color_otro font-weight-black">
                                    Sin Programar
                                </v-chip>
                            </template>


                            <template v-slot:[`item.programar`]="{ item }">
                                <v-btn class="btn_block_style2" v-if="item.clase_programada===0" small dark  @click="$emit('addselecclaseec', item, asociarCl.contenidoTipo)"> PROGRAMAR</v-btn>
                            </template>


                            <template v-slot:[`item.action_ver`]="{ item }">
                                <v-tooltip bottom color="#1b1b1b">
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-if="componenteEvento.visualizar_submodulo" v-on="on" class="btn_ver px-0 mx-0" fab x-small @click="$emit('visorec', item.id_clase, asociarCl.contenidoTipo)">
                                            <v-icon>fa-eye</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>VER CLASE</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>

                        <!-- {{clasesColegio}} -->

                    </v-card-text>



                </v-card>

            </v-dialog>
        </v-form>




    </div>
</template>

<script>

    import axios from "../../../../helpers/axios";
    import {mapMutations, mapGetters, mapActions} from 'vuex'

    export default {
        name:'modalseleccionarclasetemasec',

        props:['modalSelecClaseEC', 'datosSelecClaseEC', 'actualizarConsultaEC'],


        data: () => ({
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            paramComponente:{ 'id_submodulo':26, "id_modulo": 7}, //sud_modulo y modulo

            datoLogin: sessionStorage, // variables de sesion del usuario
            ////////////////////////////////////////////////////////

            // modal asociar clase
            //asociarCl : [],
            asociarCl : {contenidoTipo:null, id_nivel:"", id_grado:"", id_area:"", id_curso:""},
            search_asociarCl : '',

            inhabilitarNivelCl:true,
            inhabilitarGradoCl:true,
            inhabilitarAreaCl:true,
            inhabilitarCursoCl: true,

            visualizarFiltro: false,


            //- ck1
            tablaCk1: true,
            clases :[],
            headers_clases: [
                /* { text: 'ID', align: 'left', value: 'id', class:'secondary'}, */
                { text: 'GRADO', value: 'desc_grado', class:'secondary black--text' },
                { text: 'TEMA', value: 'nombre_tema', class:'secondary black--text' },
                { text: 'CLASE', value: 'nombre_clase', class:'secondary black--text' },
                { text: 'FECHA CREACIÓN', value: 'fecha_ingreso', sortable: false, class:'secondary black--text'},
                { text: 'ESTADO', value: 'estadoValor', sortable: false, align:'center', class:'secondary black--text'},
                { text: 'PROGRAMAR', value: 'programar', class:'secondary black--text' },
                { text: 'VER CLASE', value: 'action_ver', sortable: false, align:'center', class:'secondary black--text px-0 mx-0', width:'1'},
            ],


            //- colegio
            tablaColegio: false,
            clasesColegio: [],
            headers_clases_colegio: [
                /* { text: 'ID', align: 'left', value: 'id', class:'secondary'}, */
                { text: 'GRADO', value: 'desc_grado', class:'secondary black--text' },
                { text: 'TEMA', value: 'nombre_tema', class:'secondary black--text' },
                { text: 'CLASE', value: 'nombre_clase', class:'secondary black--text' },
                { text: 'FECHA CREACIÓN', value: 'fechaCreacion', sortable: false, class:'secondary black--text'},
                /* { text: 'AUTOR', value: 'fecha_ingreso', sortable: false, class:'secondary black--text'}, */
                { text: 'ESTADO', value: 'estadoValor', sortable: false, class:'secondary black--text'},
                { text: 'PROGRAMAR', value: 'programar', class:'secondary black--text' },
                { text: 'VER CLASE', value: 'action_ver', sortable: false, align:'center', class:'secondary black--text px-0 mx-0', width:'1'},
            ],



            nivelCont  :[],
            id_nivelFiltro: '',

            gradoCont  :[],
            id_gradoFiltro: [],

            gradoContFilter  :[],

            areaCont   :[],
            areaContFilter: [],
            id_areaFiltro: [],

            cursoCont  :[],
            cursoContFilter:[],
            id_cursoFiltro: [],
        }),


        computed: {
            ...mapGetters('login', [ 'componenteEvento']),

        },


        watch: {

            // cada vez que la pregunta cambie, esta función será ejecutada
            actualizarConsultaEC: function () {
                if(this.actualizarConsultaEC == true){
                    this.cargarClases()
                    //this.actualizarParamentro() FUNCION QUE PERMITE BLOQUEAR O HABILITAR FUNCIONES DE VER, EDITAR, ELIMINAR, CREAR, POR PERFIL

                }else{
                    /* this.parametrosAsistencia = {}
                    this.AlumnosSeccion = [] */
                }
            },


            modalSelecClaseEC: function () {
                if(this.modalSelecClaseEC == false){
                    this.limpiarModal()

                }else{
                    /* this.parametrosAsistencia = {}
                    this.AlumnosSeccion = [] */
                }
            }
        },


        created(){
            //this.actualizarParamentro()
            //this.getEvents()
        },


        methods: {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),

            //----- Validar accesos por perfil ------------
            ...mapActions('login',['parametroComponente'] ),

            actualizarParamentro() {
                this.parametroComponente(this.paramComponente)
            },
            ////////////////////////////////////////////////////////




            limpiarModal(){
                this.asociarCl = {contenidoTipo:null, id_nivel:"", id_grado:"", id_area:"", id_curso:""}
                this.search_asociarCl  =  ''

                this.inhabilitarNivelCl = true
                this.inhabilitarGradoCl = true
                this.inhabilitarAreaCl = true
                this.inhabilitarCursoCl =  true

                this.tablaCk1 = true
                this.clases  = []
                this.tablaColegio = false
                this.clasesColegio = []


                this.nivelCont   = []
                this.id_nivelFiltro = ''

                this.gradoCont   = []
                this.id_gradoFiltro = []

                this.gradoContFilter = []

                this.areaCont    = []
                this.areaContFilter = []
                this.id_areaFiltro = []

                this.cursoCont   = []
                this.cursoContFilter = []
                this.id_cursoFiltro = []

            },




            // carga la consultas de contenido de ck1 o del colegio segun el tipo de contenido seleccinado (ck1 o colegio)
            async cargarQueryContenido(){
                try {
                    this.clases =[]
                    this.asociarCl.id_nivel  = ""
                    this.asociarCl.id_grado  = ""
                    this.asociarCl.id_area   = ""
                    this.asociarCl.id_curso  = ""

                    this.inhabilitarNivelCl = false
                    this.inhabilitarGradoCl = true
                    this.inhabilitarAreaCl  = true
                    this.inhabilitarCursoCl = true

                    // contenido clicken 1
                    if(this.asociarCl.contenidoTipo == "1"){

                        this.id_nivelFiltro = 'id'
                        this.id_gradoFiltro = 'id'
                        this.id_areaFiltro = 'id'
                        this.id_cursoFiltro = 'id'

                        this.tablaCk1 = true
                        this.tablaColegio = false
                        this.visualizarFiltro = false


                        let response = await axios.get(`/academico/progDocente/getQueryContCk1General`)
                        //alert(JSON.stringify(response.data))

                        this.nivelCont  = response.data.NivelCkOne
                        this.gradoCont  = response.data.GradoCkOne
                        this.areaCont   = response.data.AreaCkOne
                        this.cursoCont  = response.data.CursoCkOne


                        /////////////////////////////////////////////
                        // contenido general 15/05/2020
                        this.inhabilitarAreaCl = false
                        this.areaContFilter = this.areaCont
                        ///////////////////////////////////////////
                    }


                    // contenido del colegio
                    else if(this.asociarCl.contenidoTipo == "0"){
                        this.id_nivelFiltro = 'id_nivel'
                        this.id_gradoFiltro = 'id_grado'
                        this.id_areaFiltro = 'id_area'
                        this.id_cursoFiltro = 'id_curso'

                        this.tablaCk1 = false
                        this.tablaColegio = true
                        this.visualizarFiltro = true

                        await this.cargarFiltros()


                        this.asociarCl.id_nivel = this.datosSelecClaseEC.id_nivel
                        this.eventNivelCl()

                        this.asociarCl.id_grado = this.datosSelecClaseEC.id_grado
                        this.eventGradoCl()

                        this.asociarCl.id_area = this.datosSelecClaseEC.id_area
                        this.eventAreaCl()

                        this.asociarCl.id_curso = this.datosSelecClaseEC.id_curso
                        this.cargarClases()
                    }

                }
                catch (error) {
                    this.setEnviarMens({tipo:"E", mensaje: `Error: ${error}`, tiempo:null})
                }
            },



            cargarFiltros(){
                this.nivelCont  = this.datosSelecClaseEC.nivelDoc
                this.gradoCont  = this.datosSelecClaseEC.gradoDoc
                this.areaCont   = this.datosSelecClaseEC.areaDoc
                this.cursoCont  = this.datosSelecClaseEC.cursoDoc
            },



            // carga las clases de los gestor de contenidos segun los filtros seleccionados
            async cargarClases(){
                try {
                    let params = Object.assign({periodo: this.datoLogin.id_ano_lectivo}, this.asociarCl)


                    // contenido clicken 1
                    if(this.asociarCl.contenidoTipo == "1"){
                        ///////////////////////////////////////////
                        // contenido general 15/05/2020
                        let response = await axios.post(`/academico/progDocente/getClasesCk1General`,params)
                        this.clases  = response.data.payload;
                    }

                    // contenido del colegio
                    else if(this.asociarCl.contenidoTipo == "0"){
                        let response = await axios.get(`/academico/progDocente/getContenidoColegio/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/area/${this.asociarCl.id_area}/curso/${this.asociarCl.id_curso}/usuario/${this.datoLogin.id}`)
                        this.clasesColegio  = response.data.ContenidoColegio
                    }
                }
                catch (error) {
                    this.setEnviarMens({tipo:"E", mensaje: `Error: ${error}`, tiempo:null})
                }

            },



            //  manejador del evento nivel de la programacion de clase
            eventNivelCl(){
                this.inhabilitarGradoCl = false
                this.inhabilitarAreaCl  = true
                this.inhabilitarCursoCl = true
                this.clases             = []
                this.clasesColegio      = []

                // filtro y cargo los valores del grado segun el nivel
                //let filtro = this.asociarCl.id_nivel
                this.gradoContFilter = this.gradoCont.filter(el=>el.id_nivel == this.asociarCl.id_nivel)
            },



            // manejador del evento grado de la programacion de clase
            eventGradoCl(){
                this.inhabilitarAreaCl  = false
                this.inhabilitarCursoCl = true
                this.clases             = []
                this.clasesColegio      = []

                if(this.asociarCl.contenidoTipo == "1"){
                    this.areaContFilter = this.areaCont
                }

                // contenido del colegio
                else if(this.asociarCl.contenidoTipo == "0"){
                    this.areaContFilter = this.areaCont.filter(el=>el.id_grado == this.asociarCl.id_grado)
                }
            },



            // manejador del evento area de programacion de clase
            eventAreaCl(){
                this.inhabilitarCursoCl = false

                this.clases             = []
                this.clasesColegio      = []
                //this.cargarClases()
                // filtro y cargo los valores del los curso segun el grado
                if(this.asociarCl.contenidoTipo == "0"){
                    let resultFiltroCurso = this.cursoCont.filter(el=>el.id_area == this.asociarCl.id_area)
                    this.cursoContFilter = resultFiltroCurso.filter(el=>el.id_grado == this.asociarCl.id_grado)
                }else{
                    ///////////////////////////////////////////////////////////////////////////////////////
                    // contenido General 15/05/2020
                    this.cursoContFilter = this.cursoCont.filter(el=>el.id_area == this.asociarCl.id_area)
                    ///////////////////////////////////////////////////////////////////////////////////////
                }


            },

        },
    }
</script>

